import React, { useState } from 'react';
import { FilterContainer, FormContainer } from './styles';

import { Title } from '@gerdau/hefesto/Title';
import { TextField } from '@gerdau/hefesto/TextField';
import { Icon } from '@gerdau/hefesto/Icon';
import { Button } from '@gerdau/hefesto/Button';
import { Skeleton } from '@gerdau/hefesto/Skeleton';
import { IInternalUser } from '../../../store/ducks/internal-user/types';

interface IinternalUsersFilter {
  internalUsers: IInternalUser[];
  onFilter(filteredinternalUsers: IInternalUser[]): void;
}

const InternalUsersFilter: React.FC<IinternalUsersFilter> = ({
  internalUsers,
  onFilter
}) => {
  const [searchValue, setSearchValue] = useState('');

  const onChangeValue = (value: string) => {
    setSearchValue(value);

    const filteredinternalUsers =
      value !== ''
        ? internalUsers.filter(
            (user) =>
              user.name.toLowerCase().includes(value.toLowerCase()) ||
              user.email.includes(value) ||
              user.salesRepCode.find((code: string) => code === value)
          )
        : internalUsers;

    onFilter(filteredinternalUsers);
  };

  const onPasteValue = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    onChangeValue(e.clipboardData.getData('text'));
  };

  const clearValue = () => {
    onChangeValue('');
  };

  return (
    <>
      <FilterContainer>
        <Title level={3}>Filtros</Title>
        <FormContainer>
          <div className="input-wrapper">
            {!internalUsers ? (
              <Skeleton type="input" />
            ) : (
              <TextField
                label={'Pesquisar'}
                placeholder={'Buscar usuários internos'}
                name={'Search'}
                value={searchValue}
                onChange={(e) => onChangeValue(e.target.value)}
                onPaste={(e) => onPasteValue(e)}
                icon={<Icon option={'Search'} />}
                iconPosition="left"
                type="search"
                disabled={!internalUsers}
              />
            )}
          </div>
          <Button
            loading={!internalUsers}
            onClick={() => {
              clearValue();
            }}
            disabled={!internalUsers}
            name={'cleanFilter'}
            fullWidth
            variant="secondary"
          >
            Limpar filtro
          </Button>
        </FormContainer>
      </FilterContainer>
    </>
  );
};

export default InternalUsersFilter;
